import BillingCliMasterWarehouseIndex from "@/components/billing/cli_master_warehouse/BillingCliMasterWarehouseIndex.vue";

let routesBillingCliMasterWarehouse= [
    {
        path: '',
        meta: {
          title: "Billing CLI Master Warehouse",
        },
        name: "BillingCliMasterWarehouseIndex",
        component: BillingCliMasterWarehouseIndex
    },
    
]

export default routesBillingCliMasterWarehouse
  